import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, Observable } from 'rxjs';
import { JWTService } from '../service/jwt.service';

export const AnonymousGuard: CanActivateFn = (route, state) => {
  const authService = inject(JWTService);
  const router = inject(Router);
  const pendingEmailSignup = localStorage.getItem('pendingEmailSignup');
  const isLoggedIn$: Observable<boolean> = authService.isLoggedIn();
  return isLoggedIn$.pipe(
    map((isLoggedIn) => {
      if (isLoggedIn) {
        const redirectUrl = route.queryParams['returnUrl'] || '/';
        console.log('AnonymousGuard: redirect to ' + redirectUrl);
        return router.createUrlTree([redirectUrl]);
      }
      if (pendingEmailSignup) {
        console.log('AnonymousGuard: allow while pending signup');
        return true;
      }
      console.log('AnonymousGuard: true');
      return true;
    }),
  );
};
